/**
 * Notification type sent to users.
 */
export enum UserNotificationTypeModel {
	/**
	 * A user was tagged in a comment.
	 */
	UserTaggedInComment = 1
}
